import {
  InstantUploadFileField,
  InstantUploadFileFieldProps,
} from '@components/instant-upload-file-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormInstantUploadFileFieldProps<T> = FormFieldProps<InstantUploadFileFieldProps, T>;

export function FormInstantUploadFileField<T>(props: FormInstantUploadFileFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <InstantUploadFileField {...props} {...formFieldProps} />;
}
